import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AlertsConfig, AlertsPeriod } from 'src/app/_models';
import { DropdownItem } from 'src/app/helpers/dropdownItem';

@Component({
    standalone: false,
  selector: 'scheduler',
  templateUrl: './scheduler.component.html',
  styleUrls: ['./scheduler.component.css'],
})
export class SchedulerComponent implements OnInit {
  @Input() schedule: AlertsConfig;
  @Input() scheduleForm: FormGroup;

  periods: DropdownItem<number>[] = [
    { name: 'None', value: 0 },
    { name: 'Daily', value: 1 },
    { name: 'Weekly', value: 2 },
    { name: 'Monthly', value: 3 },
    { name: 'Yearly', value: 4 },
  ];

  allDaysOfWeek: DropdownItem<number>[];
  allMonths: DropdownItem<number>[];
  allDaysInMonth: DropdownItem<number>[];
  selectedDaysOfMonth: DropdownItem<number>[] = [];
  selectedDaysOfWeek: DropdownItem<number>[] = [];
  selectedMonths: DropdownItem<number>[] = [];

  constructor(private fb: FormBuilder) {
    this.allDaysOfWeek = [
      { name: 'Sunday', value: 1 },
      { name: 'Monday', value: 2 },
      { name: 'Tuesday', value: 3 },
      { name: 'Wednesday', value: 4 },
      { name: 'Thursday', value: 5 },
      { name: 'Friday', value: 6 },
      { name: 'Saturday', value: 7 },
    ];

    this.allMonths = [
      { name: 'January', value: 1 },
      { name: 'February', value: 2 },
      { name: 'March', value: 3 },
      { name: 'April', value: 4 },
      { name: 'May', value: 5 },
      { name: 'June', value: 6 },
      { name: 'July', value: 7 },
      { name: 'August', value: 8 },
      { name: 'September', value: 9 },
      { name: 'October', value: 10 },
      { name: 'November', value: 11 },
      { name: 'December', value: 12 },
    ];

    this.allDaysInMonth = [];
    for (let index = 1; index < 32; index++) {
      this.allDaysInMonth.push({ name: index.toString(), value: index });
    }
  }

  ngOnInit(): void {
    this.scheduleForm.addControl('time', this.fb.control(''));
    if (this.scheduleForm.value.startDateTime?.endsWith && this.scheduleForm.value.startDateTime?.endsWith('Z')){
      this.scheduleForm.controls.startDateTime.patchValue(new Date(this.scheduleForm.value.startDateTime));
    }
    if (this.scheduleForm.value.endDateTime?.endsWith && this.scheduleForm.value.endDateTime?.endsWith('Z')){
      this.scheduleForm.controls.endDateTime.patchValue(new Date(this.scheduleForm.value.endDateTime));
    }

    let initialSchedule: Record<string, any> = {};

    if (!this.schedule) {
      const endDate = new Date();

      initialSchedule.startDateTime = new Date();
      endDate.setFullYear(endDate.getFullYear() + 1);
      initialSchedule.endDateTime = endDate;
      initialSchedule.period = AlertsPeriod.Monthly;

      this.setNow();
    } else {
      initialSchedule.daysOfMonth = this.schedule.daysOfMonth
        ? this.schedule.daysOfMonth.map((i) => ({
            name: `${i}`,
            value: i,
          }))
        : [];

      initialSchedule.months = this.schedule.months
        ? this.schedule.months.map((i) => ({
            name: this.allMonths.find((m) => m.value === i).name,
            value: i,
          }))
        : [];

      initialSchedule.daysOfWeek = this.schedule.daysOfWeek
        ? this.schedule.daysOfWeek.map((i) => ({
            name: this.allDaysOfWeek.find((d) => d.value === i).name,
            value: i,
          }))
        : [];

      if (this.schedule.hours && this.schedule.minutes) {
        initialSchedule.time = `${this.schedule.hours}:${this.schedule.minutes}`;
      } else {
        this.setNow();
      }
    }

    this.scheduleForm.patchValue(initialSchedule);
  }

  setNow() {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const time = `${hours}:${minutes}`;

    this.scheduleForm.patchValue({ time, hours, minutes });
  }

  onTimeChanged() {
    const match = this.scheduleForm.get('time')?.value?.match(/(\d\d):(\d\d)/);

    if (match && match.length === 3) {
      const time = {
        hours: parseInt(match[1]),
        minutes: parseInt(match[2]),
      };

      this.scheduleForm.patchValue(time);
    }
  }
}
